<template>
    <div>

        <!-- Banner -->
        <banner-generic :data="data.hero" />

        <!--        <div class="padding&#45;&#45;lg">-->
        <!--            <element-text v-if="content.text" :data="content.text" />-->
        <!--        </div>-->

        <section class="search">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <div class="search-form">
                            <form >
                                <div class="form-group">
                                    <label for="Search">Start your search</label>
                                    <input type="text" class="form-control" :value="data.query" placeholder="Enter a keyword or phrase" id="search" name=Search>
                                </div>
                                <div class="form-group">
                                    <button type="Search" class="button button--solid-black">Search</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Select house type section -->
        <section class="space-bottom--lg">
            <div class="container">
                <div class="" v-if="data.query" >
                    <div class="" v-if="data.totalItems === 0" >
                        <div class="result" >
                            <div class="row">
                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                    
                                    <a>
                                        <div class="result-wrapper">
                                            <div class="summary-wrapper">
                                                <p>You searched for "{{data.query}}".</p>
                                                <p>Sorry, your search query did not return any results.</p>
                                            </div>
                                        </div>
                                    </a>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="" v-else>
                </div>

                <div class="" v-if="data.totalItems" >
                    <div class="result-count">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <div>
                                    {{data.totalItems}} results for '{{data.query}}'
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="result" v-for="(item, itemIndex) in limitedItems">
                        <div class="row" >
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <hr >
                                <a 
                                    :href="items[itemIndex].pageLink" 
                                    class="search-result--link"
                                    :target="items[itemIndex].type === 'download' ? '_blank' : '_self'"
                                >
                                    <h4>{{items[itemIndex].pageTitle}}</h4>
                                    <div class="result-items" v-for="result in items[itemIndex]['searchItems']">
                                        <div v-if="result.Image" class="image-wrapper"> <!-- add v-if here if image exist -->
                                            <h5 v-html="result.Title"></h5>
                                        </div>
                                        
                                        <div class="summary-wrapper" v-if="result.Summary">
                                            <div v-html="result.Summary.replace(/<p>(.*)<\/p>/g, '$1')"></div>
                                        </div>
                                        <div class="clearfix"></div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    
                    <div class="load">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <div class="text-center">
                                    <div v-if="itemsToShow < data.searchItems.length && data.searchItems.length > itemsToShow">
                                        <button class="button button--solid-black load-more-button" @click="loadMoreItems()">
                                            Load more
                                        </button>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>

import {
    BannerGeneric,
    // ElementText
} from "../components";

export default {
    name: "v-search",
    components: {
        BannerGeneric,
        // ElementText
    },
    props: {
        data: {
            type: Object
        }
    },
    data () {
        return {
            showPerPage: 6,
            itemsToShow: 0,
            items: [],
            limitedItems: [],
            none: 0,
        }
    },
    methods: {
        loadMoreItems () {
            let app = this;
            app.itemsToShow += app.showPerPage;
            let limitedItems = [];

            for (let i = 0; i < app.itemsToShow; i++) {
                if(this.data.searchItems[i]){
                    limitedItems.push( this.data.searchItems[i] );
                }
            }

            app.limitedItems = limitedItems;
        },
        getFilename (url) {
            return url.split('/').reverse()[0];
        }
    },
    mounted() {
        this.items = JSON.parse( JSON.stringify( this.data.searchItems ) )
        this.loadMoreItems();
    },
};
</script>

<style lang="scss" scoped>

.search-result--link {
    display: block;
    cursor: pointer;
}

.result{
    h4{
        font-family: "Untitled Sans Medium";
        font-size: 25px;
        line-height: 40px;
    }

    .image-wrapper{
        display:flex;
        margin-right: 20px;
        align-items: center;

        img{
            display: inline-block;
            max-width: 120px;
            width: 100%;
        }
        h5{
            display: inline-block;
        }
    }
    .clearfix{
        margin-top: 1rem;
    }
}

.search-form {
    padding: 60px 0 2rem;
    // border-bottom: 1px solid #2D2C2C;

    form {
        max-width: 500px;

        label{
            margin-bottom:35px;
            font-size: 16px;
            line-height: 40px;
            font-family: "Untitled Sans Medium";
            margin-bottom: 20px;
        }

        input{
            font-size: 16px;
            line-height: 40px;
            font-family: "Untitled Sans Medium";
            padding: 5px 15px;
        }

        .button{
            min-width: 110px;
            font-size: 16px;
            padding: 12px 20px;

        }

    }
}

img {
    width: 100%;
}

.load-more-button{
    margin-top:200px;
    padding: 12px 30px;
    min-width: 110px;
    font-size: 16px;

}

</style>

